import * as animations from './animations';
import * as helpers from '../helpers';

/**
 * Checks if provided elements are in view or not with the option of a callback.
 * @param {Array.<HTMLElement>} elements 
 * @param {function} [cb]
 */
export function observe(elements, cb) {
  const observer = new IntersectionObserver((entries) => {    
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        if (cb) {
          cb(entry, i, observer)
        }
      }
    })
  })

  elements.forEach(elm => {
    observer.observe(elm)
  })
}

/**
 * Controls the playback of a video at the condition of it being in view.
 */
export function observeVideoPlayback() {
  observe(document.querySelectorAll('main video'), (entry) => {
    let vid = entry.target;
    if (entry.isIntersecting && vid.readyState == 4) {
      vid.play()
    } else {
      vid.pause()
    }
  })
}

/**
 * As soon as the queued element (`.animate`) is in view, animation is applied.
 */
export function observeElementAnimation() {
  observe(document.querySelectorAll('.animate'), (entry, i, observer) => {
    animations.element(entry.target, i);
    observer.unobserve(entry.target)
  })
}

/**
 * Images with attribute `[data=-src]` refers to yet to be loaded, this handles the update of images once in view to save data.
 */
export function observeMediaContent() {
  observe(document.querySelectorAll('main [data-src]'), (entry, i, observer) => {
    helpers.updateImage(entry.target);
    observer.unobserve(entry.target)
  })
}